import clsx from "clsx";
import React from "react";
// @ts-ignore
import styled from "styled-components";
import { Colors } from "../@types/color";
import Lottie from "lottie-react";
import loading from "./loading.json";
import "./index.css";

interface PropsType {
  color?: Colors;
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string | object;
}
export default function Skeleton(props: PropsType) {
  const { width, height, color, className, radius } = props;
  const Div = styled.span`
    width: ${width};
    height: ${height};
    background-color: ${color};
    border-radius: ${radius};
  `;
  return <Div className={clsx("customSkeleton", className)} />;
}

interface PropsType {
  message?: string;
  textClass?: string;
}
export function GSkeleton(props: PropsType) {
  return <Lottie animationData={loading} loop={true} />;
}
